<script lang="ts" setup>
  import type { Song } from '../../../../shared/api/song.ts';

  defineProps<{ song: Song }>();
</script>

<template>
  <div class="suggestion-row">
    <div class="album-art">
      <img :alt="song.title" :src="song.albumImages[1]" />
    </div>
    <div class="song-info">
      <p class="title">{{ song.title }}</p>
      <p class="artists">[{{ song.artists.join(', ') }}] ({{ song.year }})</p>
    </div>
  </div>
</template>

<style scoped>
  .suggestion-row {
    align-items: center;
    border-bottom: 1px solid var(--color-border-subtle);
    cursor: pointer;
    display: flex;
    gap: 1rem;
    padding: 0.75rem 1rem;
    transition: all 0.2s ease-in-out;
  }

  .suggestion-row:last-child {
    border-bottom: none;
  }

  .suggestion-row:hover {
    background-color: var(--color-surface-hover);
  }

  .title {
    color: var(--color-text);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-strong);
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .suggestion-row:hover .title {
    color: var(--color-primary);
  }

  .suggestion-row:active {
    background: var(--color-surface-pressed);
  }

  .album-art {
    background: var(--color-placeholder);
    border-radius: var(--radius-sm);
    flex-shrink: 0;
    height: 48px;
    overflow: hidden;
    width: 48px;
  }

  .album-art img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  .song-info {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    overflow: hidden;
  }

  .artists {
    color: var(--color-text-secondary);
    font-size: var(--font-size-sm);
    font-weight: 400;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
